/**
 * The web app's one post-sign-in redirect rule, shared by the magic-link landing
 * (`MagicLoginPage`) and the SSO completion page (`SsoCompletePage`), and used by the SSO
 * buttons to decide whether a `next` is worth sending. Moved here from `MagicLoginPage.tsx`
 * (sso-login Phase 4) so there is one owner of the rule.
 *
 * Only accept internal paths as a redirect target (defends against open-redirect via a crafted
 * `next`); anything else falls back to root. The rule mirrors the API's `safeSsoNext`
 * (`apps/api/src/modules/auth/sso/schema.ts`): a leading `/`; a second character that is
 * neither `/` nor `\` (browsers read `/\evil.com` as `//evil.com`); no control characters
 * (browsers strip tab/CR/LF, so `/\t/evil.com` becomes `//evil.com`); at most 512 characters.
 */
const NEXT_MAX_LENGTH = 512;

const CONTROL_CHARACTER = /[\u0000-\u001f\u007f]/;

export function safeNext(next: string | null): string {
  if (
    next &&
    next.length <= NEXT_MAX_LENGTH &&
    next.startsWith('/') &&
    next[1] !== '/' &&
    next[1] !== '\\' &&
    !CONTROL_CHARACTER.test(next)
  ) {
    return next;
  }
  return '/';
}
